(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MedalDialogController', MedalDialogController);

    MedalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Medal','MedalTag'];

    function MedalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Medal,MedalTag) {
        var vm = this;

        vm.medal = entity;
        vm.clear = clear;
        vm.save = save;
        vm.addTag = addTag;
        vm.removeTag = removeTag;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
            loadAllMedalTags();
            loagAllTags();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medal.id !== null) {
                Medal.update(vm.medal, onSaveSuccess, onSaveError);
            } else {
                Medal.save(vm.medal, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:medalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function loagAllTags(){
            if(vm.medal.id){
                MedalTag.tagsAvailable({}, function (data) {
                    vm.tagsAvailable = data;
                    console.log(data);
                });
            }
        }

        function loadAllMedalTags(){
            if(vm.medal.id){
                MedalTag.allMedalTags({medalId: vm.medal.id}, function (data) {
                    vm.medalTags = data;
                    console.log(data);
                });
            }

        }

        function addTag(){

            var notContains = true;

            for (var x = 0; x < vm.medalTags.length; x++) {
                if (vm.medalTags[x].id === vm.tagSelected.id) {
                    notContains = false;
                }
            }

            if(notContains){
                MedalTag.addTag({medalId: vm.medal.id,tagId:vm.tagSelected.id},null, function (data) {
                    vm.medalTags.push(angular.copy(vm.tagSelected));
                    vm.tagSelected = null;
                });
            }else{
                vm.tagSelected = null;
            }

        }

        function removeTag(tag,idx){
            MedalTag.removeTag({medalId: vm.medal.id,tagId:tag.id}, function (data) {
                vm.tagSelected = null;
                vm.medalTags.splice(idx,1);
            });
        }

    }
})();
